module.exports = __webpack_public_path__ + "static/island-a86b91381bbdf56025d4947f0f26ec5a.svg";